{
  "api": {
    "locationValidationTitle": "We could not validate your location",
    "thresholdTitle": "Not on time to check-in",
    "warehouseUnavailableTitle": "Warehouse not available",
    "warehouseUnavailableMessage": "Please contact the facility personnel to proceed with manual check-in",
    "characterLimitTitle": "Input exceeds character limit",
    "genericTitle": "Check-in failed. Please, try again.",
    "recaptchaTitle": "Verification failed",
    "recaptchaMessage": "We could not verify your request. Please try again or contact the facility personnel."
  }
}
